import { useQuery } from '@tanstack/react-query';
import { Auth0DecodedHash } from 'auth0-js';

import { isUserAuthenticated } from 'src/auth/auth0';

export const useIsUserAuthenticated = (enabled = true) => {
    const query = useQuery<Auth0DecodedHash | null>({
        enabled,
        queryKey: ['isUserAuthenticated'],
        queryFn: isUserAuthenticated,
    });
    return { ...query };
};
